import { isElementType } from '@lumapps/wrex/slate/utils/isElementType';

import { UnorderedList } from '../components/blocks/UnorderedList';

export const isUnorderedList = isElementType(UnorderedList);
